import Icon from '../../fragments/icon/Icon';
import IconPlus from '../../fragments/icon/IconPlus';
import RichText from '../../fragments/rich-text/RichText';

export default function AccordionPanel({
  panel,
  blockId,
  index,
  expanded,
  toggle,
}) {
  if (!panel) return null;

  return (
    <div
      className={`Accordion-panelRow Accordion-panelRow--${
        expanded ? 'is-expanded' : 'is-not-expanded'
      }`}
      aria-expanded={expanded}
    >
      <div className={'Accordion-panelHeading'}>
        <div className="Accordion-panelTitle">
          <p
            className={'h5 headingStrong'}
            dangerouslySetInnerHTML={{ __html: panel.heading }}
          ></p>
        </div>
        <div
          id={`${blockId}-panel-${index}`}
          className={`Accordion-panelContent Accordion-panelContent--${
            expanded ? 'is-expanded' : 'is-not-expanded'
          }`}
          aria-hidden={!expanded}
        >
          {panel?.contentHtml && (
            <RichText
              className={'Accordion-panelContentInner'}
              html={panel.contentHtml}
            />
          )}
        </div>
        <IconPlus open={expanded} />
        <button
          className={'Accordion-toggleButton'}
          onClick={() => toggle(panel.id)}
          type="button"
          aria-expanded={expanded}
          aria-controls={`${blockId}-panel-${index}`}
          aria-label={expanded ? 'Collapse content' : 'Expand content'}
        ></button>
      </div>
    </div>
  );
}
